module.exports = __webpack_public_path__ + "img/hand-coin-line.2758dcb5.svg";